import { makeAutoObservable } from 'mobx'
import { InformalFeedbackRequest } from 'api/clients/InformalFeedbackRequestsClient'

export type InformalFeedbackRequestLike = Pick<InformalFeedbackRequest, 'section_uuid' | 'key'>

export class Review {
  selectedRequest?: InformalFeedbackRequestLike = undefined
  enabled: boolean = false
  mutationObserver?: MutationObserver = undefined

  constructor() {
    makeAutoObservable(this)
  }

  select(informalFeedbackRequest: InformalFeedbackRequestLike) {
    this.selectedRequest = informalFeedbackRequest
    this.resetObserver()
  }

  clear() {
    this.selectedRequest = undefined
    this.resetObserver()
  }

  scrollToSection() {
    if (!this.selectedRequest?.section_uuid) return
    const querySelector = `[data-uuid="${this.selectedRequest.section_uuid}"]`
    const review = document.querySelector(querySelector)
    if (review) {
      review.scrollIntoView({ behavior: 'smooth' })
    } else {
      this.observeSection(querySelector)
    }
  }

  private resetObserver() {
    this.mutationObserver?.disconnect()
    this.mutationObserver = undefined
  }

  private observeSection(querySelector: string) {
    const observer = new MutationObserver((_, observer) => {
      const review = document.querySelector(querySelector)
      if (review) {
        review.scrollIntoView({ behavior: 'smooth' })
        this.resetObserver()
      }
    })
    observer.observe(document, {
      subtree: true,
      childList: true,
      attributes: true,
    })
    this.mutationObserver = observer
  }
}

export const reviewStore = new Review()
